import { Router, NavigationEnd } from '@angular/router';
import { EntitlementService } from './../../../services/entitlement.service';
import { VisitorCardService } from './../../../services/visitor-card.service';
import { Component, OnInit } from '@angular/core';
import { VisitorCardStub } from 'src/app/data/VisitorCardStub';
import { MessageService } from 'src/app/services/message.service';

@Component({
  selector: 'app-visitor-card-search',
  templateUrl: './visitor-card-search.component.html',
  styleUrls: ['./visitor-card-search.component.css']
})
export class VisitorCardSearchComponent implements OnInit {
  visitorCardStubs: VisitorCardStub[] = null;
  recentCardStubs: VisitorCardStub[] = null;
  firstParameter: string;
  processing = false;
  noSearchParameters = false;

  constructor(
    private visitorCardService: VisitorCardService,
    private entitlementService: EntitlementService,
    private router: Router,
    private messageService: MessageService
  ) {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        if (event.url === '/visitorCards') {
          const passedParam = this.visitorCardService.getPassedParam(
            'vcSearchParam'
          );
          if (passedParam) {
            this.visitorCardStubs = null;
            this.recentCardStubs = null;
            this.firstParameter = passedParam;
            this.submit();
          }
        }
      }
    });
  }

  ngOnInit() {
    this.recentCardStubs = this.visitorCardService.getRecentVisitorCardStubs();
  }

  public hasEntitlement(entitlement: string): boolean {
    return this.entitlementService.hasEntitlement(entitlement);
  }

  submit() {
    this.visitorCardStubs = null;
    this.recentCardStubs = null;
    this.processing = true;
    this.noSearchParameters = !this.firstParameter;
    if (this.noSearchParameters) {
      this.processing = false;
      this.messageService.error('Please enter valid search criteria');
      return;
    }

    const that = this;
    this.visitorCardService.getVisitorCardStubs(that.firstParameter).subscribe(
      (data: VisitorCardStub[]) => {
        that.visitorCardStubs = data;
        that.visitorCardService.clearPassedParams();
      },
      error => {
        if (error.error) {
          this.messageService.error(error.error);
        } else {
          this.messageService.error('There was an error with the search');
        }
        that.processing = false;
        console.log('There was an error fetching ship information.');
      },
      () => {
        that.processing = false;
      }
    );
  }
}
